module.exports = __webpack_public_path__ + "img/notion.2c4feded.png";